import { apiClient } from '@/core/api/client';
import type {
  SPClientInvitation,
  InvitationDetails,
  CreateInvitationRequest,
} from '../types/sp-client-management.types';

export const invitationsApi = {
  /**
   * Create new client invitation
   */
  create: async (
    providerId: string,
    data: CreateInvitationRequest
  ): Promise<SPClientInvitation> => {
    const response = await apiClient.post(
      `/service-providers/${providerId}/invitations`,
      data
    );
    return response.data;
  },

  /**
   * Get SP's sent invitations
   */
  getInvitations: async (
    providerId: string,
    status?: string
  ): Promise<{ data: SPClientInvitation[] }> => {
    const response = await apiClient.get(`/service-providers/${providerId}/invitations`, {
      params: { status },
    });
    return response.data;
  },

  /**
   * Get invitation details by token (public endpoint)
   */
  getByToken: async (token: string): Promise<InvitationDetails> => {
    const response = await apiClient.get(`/sp-invitations/${token}`);
    return response.data;
  },

  /**
   * Accept invitation
   */
  accept: async (token: string): Promise<{ message: string; client: any }> => {
    const response = await apiClient.post(`/sp-invitations/${token}/accept`);
    return response.data;
  },

  /**
   * Decline invitation
   */
  decline: async (token: string): Promise<{ message: string }> => {
    const response = await apiClient.post(`/sp-invitations/${token}/decline`);
    return response.data;
  },

  /**
   * Resend invitation email
   * Subject to 30-minute cooldown
   */
  resend: async (
    providerId: string,
    invitationId: string
  ): Promise<SPClientInvitation> => {
    const response = await apiClient.post(
      `/service-providers/${providerId}/invitations/${invitationId}/resend`
    );
    return response.data;
  },
};
